import { FC } from "react";

import MainRoutes from "./MainRoutes";

const AppRoutes: FC = (props) => {
  const routeProps = { ...props };

  return <MainRoutes {...routeProps} />;
};

export default AppRoutes;
